import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/[locale]/terms-and-conditions/client/TermsAndConditionsClient.tsx");
